import React from 'react';
import './MenuMainDesktop.scss';
import { Row, Icon } from 'antd';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Link from 'Components/Shared/Link/Link';
import MenuSearch from 'Components/MenuSearch/MenuSearch';
import { ICategory } from 'Components/MenuMain/MenuMainContent';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import DropDown, { IDropdown } from 'Components/MenuMain/DropDown/DropDown';
import MessageSliderContainer from 'Components/MessageSlider/MessageSliderContainer';
import LanguagePicker from 'Components/Shared/LanguagePicker/LanguagePicker';

interface IProps {
  isStartPage: boolean;
  isShowingSearchForm: boolean;
  homeImageUrl: string;
  dropdownDesktop: IDropdown;
  visibleCategories: ICategory[];
  emptyCategoryIDs: number[];
  onSearchIconClick: () => void;
  onSearchCloseClick: () => void;
  onSearchChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSearchSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const MenuMainDesktop: React.SFC<IProps> = ({
  isStartPage,
  isShowingSearchForm,
  homeImageUrl,
  dropdownDesktop,
  visibleCategories = [],
  emptyCategoryIDs = [],
  onSearchIconClick,
  onSearchCloseClick,
  onSearchChange,
  onSearchSubmit,
}) => {

  const hasEvents = (categoryID: number) => {
    return emptyCategoryIDs.find(id => id === categoryID);
  }

  const style = isStartPage ? 
    'menu-main-desktop start-page' : 
    'menu-main-desktop category-page';

  return (
    <div className={ style }>
      <WrapperLayout style='menu' align='middle'>
        <Link
          style='home-item'
          imageAlt='Julius Biljettservice logga'
          imageUrl={ homeImageUrl }
          localPath='/'
        />
        <Row type='flex'>
          { visibleCategories.map(c => 
            <Link 
              key={ c.id } 
              style={ `category-item${ hasEvents(c.id) ? ' empty' : '' }` }
              { ...c } 
            />)
          }
        </Row>
        { dropdownDesktop && 
          <DropDown { ...dropdownDesktop }>
            <NavLink 
              to={ dropdownDesktop.localPath } 
              className='dropdown-trigger'
            >
              <FormattedMessage 
                id={ dropdownDesktop.formattedName } 
                defaultMessage={ dropdownDesktop.displayName } 
              />
              <Icon type='down' />
            </NavLink>
          </DropDown>
        }
        <Icon 
          type='search' 
          className='search-item' 
          onClick={ onSearchIconClick } 
        />
        <LanguagePicker />
      </WrapperLayout>
      <MessageSliderContainer />
      { isShowingSearchForm && 
        <MenuSearch 
          onChange={ onSearchChange }
          onSubmit={ onSearchSubmit } 
          onClose={ onSearchCloseClick }
        /> 
      }
    </div>
  );
};

export default MenuMainDesktop;


// WEBPACK FOOTER //
// ./src/components/MenuMain/MenuMainDesktop/MenuMainDesktop.tsx